function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.98301 7.19704C6.19141 7.19704 7.17101 6.21744 7.17101 5.00904C7.17101 3.80065 6.19141 2.82104 4.98301 2.82104C3.77461 2.82104 2.79501 3.80065 2.79501 5.00904C2.79501 6.21744 3.77461 7.19704 4.98301 7.19704Z",
  fill: "#246FF2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.237 8.85505V20.9941H13.006V14.9911C13.006 13.4071 13.304 11.8731 15.268 11.8731C17.205 11.8731 17.229 13.6841 17.229 15.0911V20.9951H21V14.3381C21 11.0681 20.296 8.55505 16.474 8.55505C14.639 8.55505 13.409 9.56205 12.906 10.5151H12.855V8.85505H9.237ZM3.095 8.85505H6.87V20.9941H3.095V8.85505Z",
  fill: "#246FF2"
});

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.66478bb3.svg";
export { ForwardRef as ReactComponent };